/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any -- Additional Data doesn't have any type */
import './grid.scss'
import type { FC } from 'react'
import { cx } from '@/common/utils/className'
import type { CurzonGridRow } from './grid.types'
import { GridRowComponent } from './GridRowComponent'

export interface GridProps {
    rows: CurzonGridRow[] | undefined
    additionalData?: any
    className?: string
}

export const Grid: FC<GridProps> = props => {
    if (!props.rows?.length) return null

    const cls = cx('grid', props.className)
    return (
        <div className={cls}>
            {props.rows.map((row, index) => (
                <GridRowComponent key={'grid-row-' + index} {...row} additionalData={props.additionalData} />
            ))}
        </div>
    )
}
